import { ChevronDown } from '@volkswagen-onehub/icons-core/dist/ChevronDown';
import { ChevronUp } from '@volkswagen-onehub/icons-core/dist/ChevronUp';
import { Alert } from '@volkswagen-onehub/icons-core/dist/Alert';
import { ArrowUp } from '@volkswagen-onehub/icons-core/dist/ArrowUp';
import { ArrowDown } from '@volkswagen-onehub/icons-core/dist/ArrowDown';
import { Checkmark } from '@volkswagen-onehub/icons-core/dist/Checkmark';
import { ChevronLeft } from '@volkswagen-onehub/icons-core/dist/ChevronLeft';
import { ChevronRight } from '@volkswagen-onehub/icons-core/dist/ChevronRight';
import { ContactDealer } from '@volkswagen-onehub/icons-core/dist/ContactDealer';
import { Route } from '@volkswagen-onehub/icons-core/dist/Route';
import { Magnifier } from '@volkswagen-onehub/icons-core/dist/Magnifier';
import { Add } from '@volkswagen-onehub/icons-core/dist/Add';
import { Remove } from '@volkswagen-onehub/icons-core/dist/Remove';
import { ArrowLeft } from '@volkswagen-onehub/icons-core/dist/ArrowLeft';
import { Filter } from '@volkswagen-onehub/icons-core/dist/Filter';
import { Close } from '@volkswagen-onehub/icons-core/dist/Close';
import { Locate } from '@volkswagen-onehub/icons-core/dist/Locate';
import { Calc } from '@volkswagen-onehub/icons-core/dist/Calc';
import { Calendar } from '@volkswagen-onehub/icons-core/dist/Calendar';
import { Interior } from '@volkswagen-onehub/icons-core/dist/Interior';
import { Info } from '@volkswagen-onehub/icons-core/dist/Info';
import { Mail } from '@volkswagen-onehub/icons-core/dist/Mail';
import { Phone } from '@volkswagen-onehub/icons-core/dist/Phone';
import { FleetServicePrivate } from '@volkswagen-onehub/icons-core/dist/FleetServicePrivate';
import { CarPickupService } from '@volkswagen-onehub/icons-core/dist/CarPickupService';
import { StarFilled } from '@volkswagen-onehub/icons-core/dist/StarFilled';
import { StarOutline } from '@volkswagen-onehub/icons-core/dist/StarOutline';
import { Reload } from '@volkswagen-onehub/icons-core/dist/Reload';
import { Edit } from '@volkswagen-onehub/icons-core/dist/Edit';

export {
  ChevronDown,
  ChevronUp,
  Alert,
  ArrowUp,
  ArrowDown,
  Checkmark,
  ChevronLeft,
  ChevronRight,
  ContactDealer,
  Route,
  Magnifier,
  Add,
  Remove,
  ArrowLeft,
  Filter,
  Close,
  Locate,
  Calc,
  Calendar,
  Interior,
  Info,
  Mail,
  Phone,
  FleetServicePrivate,
  CarPickupService,
  StarOutline,
  StarFilled,
  Reload,
  Edit 
};
